import { FC } from 'react';

export const If: FC<{condition: boolean}> = ({ condition, children }) => <>{condition ? children : null}</>;
